import { apiService } from './api';
import { Customer, CreateCustomerRequest, CustomerFilters, PaginatedResponse } from '../types';

export const customerService = {
  // Create customer
  create: async (customer: CreateCustomerRequest): Promise<Customer> => {
    const response = await apiService.post<Customer>('/customers', customer);
    return response.data;
  },

  // Get customer by ID
  get: async (id: string): Promise<Customer> => {
    const response = await apiService.get<Customer>(`/customers/${id}`);
    return response.data;
  },

  // Update customer
  update: async (id: string, customer: Partial<Customer>): Promise<Customer> => {
    const response = await apiService.put<Customer>(`/customers/${id}`, customer);
    return response.data;
  },

  // Delete customer
  delete: async (id: string): Promise<void> => {
    await apiService.delete<void>(`/customers/${id}`);
  },

  // List customers with pagination and filters
  list: async (filters: CustomerFilters & { page?: number; size?: number; restaurantId?: string | null }): Promise<PaginatedResponse<Customer>> => {
    const params = new URLSearchParams();
    params.append('org', filters.org);

    if (filters.restaurantId) params.append('restaurantId', filters.restaurantId);
    if (filters.name) params.append('name', filters.name);
    if (filters.mobile) params.append('mobile', filters.mobile);
    if (filters.email) params.append('email', filters.email);

    params.append('page', (filters.page || 0).toString());
    params.append('size', (filters.size || 20).toString());

    const response = await apiService.get<PaginatedResponse<Customer>>(`/customers?${params.toString()}`);
    return response.data;
  },

  // Search customers by name/mobile
  search: async (org: string, query: string, limit?: number): Promise<Customer[]> => {
    const params = new URLSearchParams();
    params.append('org', org);
    params.append('q', query);
    if (limit) params.append('limit', limit.toString());

    const response = await apiService.get<Customer[]>(`/customers/search?${params.toString()}`);
    return response.data;
  },

  // Get customers (for compatibility)
  getCustomers: async (filters: { org?: string; restaurantId?: string | null }): Promise<Customer[]> => {
    const params = new URLSearchParams();
    if (filters.org) params.append('org', filters.org);
    if (filters.restaurantId) params.append('restaurantId', filters.restaurantId);

    const response = await apiService.get<Customer[]>(`/customers?${params.toString()}`);
    return response.data;
  }
};